/*
 * The module's own addresses, and the way it navigates to them.
 *
 * The holder itself lives in the shell (`core/shell/navigate.ts`): the sidebar this module
 * contributes is drawn on every screen with chrome, so the function it navigates through has to be
 * installed for the lifetime of the shell and not for the lifetime of a chat route — installed
 * anywhere narrower, a row clicked from an area is a document load. It is re-exported here so that
 * a surface of this module reaches its navigation through its own module, the way it reaches
 * everything else.
 */

export { navigateTo, setNavigate } from "../../core/shell/index.ts"

/** The conversation route of a channel or a private channel. */
export function conversationPath(slug: string): string {
	return `/c/${encodeURIComponent(slug)}`
}

/** The route of a dm or a group dm, addressed by its generated handle. */
export function dmPath(handle: string): string {
	return `/d/${encodeURIComponent(handle)}`
}
